
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"font-family":"sans-serif"}},[_c('path',{attrs:{"d":"M15.673.002a1 1 0 00-1 1v16.005a1 1 0 001 1 1 1 0 001-1V1.002a1 1 0 00-1-1zm-8.013 4a1 1 0 00-.64.24 1 1 0 00-.11 1.412l3.444 4.017-3.444 4.017a1 1 0 00.11 1.412 1 1 0 001.411-.11l4.002-4.668a1 1 0 000-1.302L8.431 4.352a1 1 0 00-.77-.35z","overflow":"visible"}}),_c('path',{attrs:{"d":"M2.325 4.002a1 1 0 00-.64.24 1 1 0 00-.11 1.412l3.444 4.018-3.444 4.017a1 1 0 00.11 1.412 1 1 0 001.411-.11l4.002-4.668a1 1 0 000-1.302L3.096 4.352a1 1 0 00-.77-.35z","overflow":"visible"}})])])
          )
        }
      }
    